export default __webpack_public_path__ + "assets/aeaec016d6766e2a0f4dfeaec2c0a629.woff";